import React, { useEffect, useState } from "react";
import PageHeader from "src/Components/Customer/PageHeader";
import BackIcon from "src/assets/images/back-icon.png";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import CustomerTableWrapper from "src/Components/Customer/CustomerTableWrapper";
import { IPaginated } from "src/types/paginated";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import qs from "qs";
import deleteIcon from "src/assets/images/delete-icon.png";
import {
  convertToKebabCase,
  truncateString,
} from "src/helpers/helperFunctions";
import ConfirmationModal from "src/Components/GlobalComponents/ConfirmationModal";
import SearchFilterInput from "src/Components/GlobalComponents/SearchFilterInput";
import editIcon from "src/assets/images/edit-icon.png";
import AddProductPrescribeModal from "src/Components/DoctorComponents/AddProductPrescribeModal";

type tabKeys = "pharmacy" | "diagnostic" | "homecare";
interface IItem {
  title: string;
  key: tabKeys;
}
interface IObj {
  _id?: string;
  productId?: string;
  productName?: string;
  frequency?: string;
  dosage?: string;
  instruction?: string;
}

const AppointmentPrescribe: React.FC = () => {
  const { appointmentId = "" } = useParams();
  const [searchParams] = useSearchParams()
  const type = searchParams.get("type") || "pharmacy"
  const navigate = useNavigate();
  const tabList: IItem[] = [
    { title: "Prescribe Medicines", key: "pharmacy" },
    { title: "Prescribe Test", key: "diagnostic" },
    { title: "Prescribe Services", key: "homecare" },
  ];
  const [shareLoader, setShareLoader] = useState<boolean>(false);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [data, setData] = useState<IObj[]>([]);
  const [isEdit, setIsEdit] = useState<{
    _id: string;
    productType: string;
    productId: string;
    productName: string;
    initialData: IObj | null;
  } | null>(null);
  const [queryParams, setQueryParams] = useState<{
    page: number;
    limit: number;
    appointmentId: string;
    productType: string;
    bool: boolean;
    search: string;
  }>({
    page: 1,
    limit: 10,
    appointmentId: appointmentId,
    productType: type,
    bool: false,
    search: "",
  });
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });
  const [deleteState, setDeleteState] = useState<{
    _id: null | string;
    modal: boolean;
    loader: boolean;
  }>({
    _id: null,
    modal: false,
    loader: false,
  });

  const handleDelete = (id: string) => {
    setDeleteState((prev) => ({ ...prev, modal: true, _id: id }));
  };

  const handleEdit = (id: string, productType: string, productId: string, productName: string, initialData: IObj | null) => {
    setIsEdit({ _id: id, productType: productType, productId: productId, productName: productName, initialData: initialData });
  };

  const handlePageChange = (e: number) => {
    setQueryParams((prev) => ({
      ...prev,
      page: e,
    }));
  };
  const navigateToProductPage = () => {
    if (queryParams.productType === "pharmacy") {
      navigate(
        `/customer/pharmacy-products?prescribe=${true}&appointmentId=${appointmentId}`
      );
    } else if (queryParams.productType === "diagnostic") {
      navigate(
        `/customer/diagnostic-products?prescribe=${true}&appointmentId=${appointmentId}`
      );
    } else if (queryParams.productType === "homecare") {
      navigate(
        `/doctor/homecareservices?prescribe=${true}&appointmentId=${appointmentId}`
      );
    }
  };

  const handleShare = async () => {
    setShareLoader(true);
    const { res, err } = await httpRequest<{ message: string }>({
      path: `/appoiment/share-prescribe?productType=${queryParams?.productType}`,
      method: "post",
      params: {
        appointmentId,
        prescriptionDetails: data,
      },
    });
    if (res) {
      toast(res?.message || "Success!", { type: "success" });
      setQueryParams((prev) => ({ ...prev, bool: !prev?.bool }));
    } else {
      toast(err, { type: "error" });
    }
    setShareLoader(false);
  };
  const deleteRequests = async () => {
    setDeleteState((prev) => ({ ...prev, loader: true }));
    const { res, err } = await httpRequest<{ message: string }>({
      method: "delete",
      path: `/appoiment/prescribe-delete/${deleteState._id}`,
      params: {},
    });
    if (res) {
      toast(res?.message || "Success!", { type: "success" });
      setQueryParams((prev) => ({
        ...prev,
        bool: !prev?.bool,
        page:
          data?.length > 1
            ? prev?.page
            : prev?.page > 1
            ? prev?.page - 1
            : prev?.page,
      }));
      setDeleteState((prev) => ({ ...prev, modal: false, _id: null }));
    } else {
      toast(err, { type: "error" });
    }
    setDeleteState((prev) => ({ ...prev, loader: false }));
  };

  const fetch = async () => {
    setIsLoader(true);
    const { bool, ...actualParams } = queryParams;
    const { res, err } = await httpRequest<{
      documents: IObj[];
      paginated: IPaginated;
    }>({ path: `/appoiment/prescribe-all?${qs.stringify(actualParams)}` });
    if (res) {
      const { documents = [], paginated = { currentPage: 1, totalPages: 1 } } =
        res;
      setPaginated(paginated);
      setData(documents);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetch();
  }, [queryParams]);

  useEffect(() => {
    setQueryParams((prev) => ({ ...prev, productType: type }));
  }, [type]);

  const BackButton: React.FC = () => {
    return (
      <button
        className="right-bar-icon"
        onClick={() => navigate(`/doctor/appointment/${appointmentId}/view`)}
      >
        <img src={BackIcon} alt="back-icon" />
      </button>
    );
  };
  return (
    <>
      <AddProductPrescribeModal
        appointmentId={appointmentId}
        productId={isEdit?.productId || null}
        productName={
          data?.find((v) => v._id === isEdit?._id)?.productName || ""
        }
        type={isEdit?.productType || "pharmacy" as any}
        show={isEdit ? true : false}
        onClose={() => setIsEdit(null)}
        isEdit={true}
        isEditData={isEdit?.initialData || null}
        onUpdate={(data: IObj) => {
          setData((prev) => prev.map((v) => v._id === data._id ? data : v));
          setIsEdit(null);
        }}
      />
      <PageHeader
        title="Prescribe"
        isButton={true}
        ButtonComponent={BackButton}
      />
      <ConfirmationModal
        show={deleteState.modal}
        onClose={() =>
          setDeleteState((prev) => ({ ...prev, modal: false, _id: null }))
        }
        title="Are you sure you want to delete?"
        leftBtnText="No"
        rightBtnText="Yes"
        onConfirm={deleteRequests}
        loader={deleteState.loader}
      />
      <div
        style={{
          position: "relative",
          minHeight: `calc(${
            document.getElementById("customer-sidebar-id")?.offsetHeight
          }px - 1rem - ${document.getElementById("headerH")?.offsetHeight}px)`,
        }}
        className="parent-box parent-box-height parent-box-height-new-iss-res"
      >
        <div className="flex gap-4 items-center">
          {tabList.map((item: IItem) => (
            <button
              disabled={queryParams.productType === item.key}
              id={`prescribe-tab-${convertToKebabCase(item.key)}`}
              onClick={() => {
                setQueryParams((prev) => ({
                  ...prev,
                  page: 1,
                  productType: item.key,
                }));
                setData([]);
              }}
              key={item.key}
              className={`relative border font-size-15px font-Poppins-SemiBold health-tabs-main-btn rounded-full ${
                queryParams.productType === item.key
                  ? "text-[#fff] theme-bg-green"
                  : "theme-color-green border-[#004540]"
              }`}
            >
              {item.title}
            </button>
          ))}
        </div>
        <hr className="products-tabs-hr-allOrder" />
        <div className="flex justify-between items-center mb-2">
          <SearchFilterInput
            placeHolder="Search"
            onChangeText={(value: string) => {
              setQueryParams((prev) => ({ ...prev, search: value }));
            }}
          />
          <PrimaryBtn
            ButtonText="Add New"
            onPress={navigateToProductPage}
            btnExtraStyle={{
              borderRadius: "1.5rem",
              backgroundColor: "#004540",
              padding: "5px 30px",
            }}
            id="prescribe-add-new-btn"
          />
        </div>
        {queryParams.productType === "pharmacy" ? (
          <CustomerTableWrapper
            isLoading={isLoader}
            thead={[
              "S.No",
              "Medicine",
              // "Frequency",
              "Dosage ",
              "Instructions",
              "Action",
            ]}
            page={paginated.currentPage || 1}
            total={paginated.totalPages || 0}
            columnWidth={"12% 20% 18% 38% 12%"}
            onChange={handlePageChange}
          >
            {data?.map((item: IObj, index: number) => (
              <ul
                key={index}
                className="font-size-16px tbody-light-table customer-table-wrapper-body-padding-non customer-table-wrapper-body tbody-light-table-customer font-Poppins-Regular grid"
                style={{ gridTemplateColumns: "12% 20% 18% 38% 12%" }}
              >
                <li style={{ paddingLeft: "2rem" }}>
                  {(
                    (paginated?.currentPage - 1) * queryParams.limit +
                    (index + 1)
                  )
                    .toString()
                    .padStart(2, "0")}
                </li>
                <li className="w-full"><span className="break-all truncate block">{item?.productName || ""}</span></li>
                {/* <li>{item?.frequency || ""}</li> */}
                <li>
                  {item?.dosage || "0"} Tab{Number(item?.dosage) > 1 ? "s" : ""}
                </li>
                <li title={item?.instruction} className="block w-full">
                  <span className="line-clamp-2">{item?.instruction}</span>
                </li>
                <li className="action-last-colum">
                  <img
                    id={`edit-icon-${index + 1}`}
                    onClick={() =>
                      handleEdit(
                        item?._id || "",
                        queryParams.productType,
                        item?.productId || "",
                        item?.productName || "",
                        item
                      )
                    }
                    src={editIcon}
                    alt=""
                  />
                  <img
                    id={`prescribe-delete-btn-${index + 1}`}
                    onClick={() => handleDelete(item?._id || "")}
                    src={deleteIcon}
                    alt="delete"
                  />
                </li>
              </ul>
            ))}
          </CustomerTableWrapper>
        ) : queryParams.productType === "diagnostic" ? (
          <CustomerTableWrapper
            isLoading={isLoader}
            thead={["S.No", "Test", "Instructions", "Action"]}
            page={paginated.currentPage || 1}
            total={paginated.totalPages || 0}
            columnWidth={"12% 26% 50% 12%"}
            onChange={handlePageChange}
          >
            {data?.map((item: IObj, index: number) => (
              <ul
                key={index}
                className="font-size-16px tbody-light-table customer-table-wrapper-body-padding-non customer-table-wrapper-body tbody-light-table-customer font-Poppins-Regular grid"
                style={{ gridTemplateColumns: "12% 26% 50% 12%" }}
              >
                <li style={{ paddingLeft: "2rem" }}>
                  {(
                    (paginated?.currentPage - 1) * queryParams.limit +
                    (index + 1)
                  )
                    .toString()
                    .padStart(2, "0")}
                </li>
                <li className="w-full"><span className="break-all truncate block">{item?.productName || ""}</span></li>
                <li title={item?.instruction}>
                  {truncateString(item?.instruction, 120)}
                </li>
                <li className="action-last-colum">
                  <img
                    id={`edit-icon-${index + 1}`}
                    onClick={() =>
                      handleEdit(
                        item?._id || "",
                        queryParams.productType,
                        item?.productId || "",
                        item?.productName || "",
                        item
                      )
                    }
                    src={editIcon}
                    alt=""
                  />
                  <img
                    id={`prescribe-delete-btn-${index + 1}`}
                    onClick={() => handleDelete(item?._id || "")}
                    src={deleteIcon}
                    alt="delete"
                  />
                </li>
              </ul>
            ))}
          </CustomerTableWrapper>
        ) : queryParams.productType === "homecare" ? (
          <CustomerTableWrapper
            isLoading={isLoader}
            thead={["S.No", "Services", "Instructions", "Action"]}
            page={paginated.currentPage || 1}
            total={paginated.totalPages || 0}
            columnWidth={"12% 26% 50% 12%"}
            onChange={handlePageChange}
          >
            {data?.map((item: IObj, index: number) => (
              <ul
                key={index}
                className="font-size-16px tbody-light-table customer-table-wrapper-body-padding-non customer-table-wrapper-body tbody-light-table-customer font-Poppins-Regular grid"
                style={{ gridTemplateColumns: "12% 26% 50% 12%" }}
              >
                <li style={{ paddingLeft: "2rem" }}>
                  {(
                    (paginated?.currentPage - 1) * queryParams.limit +
                    (index + 1)
                  )
                    .toString()
                    .padStart(2, "0")}
                </li>
                <li className="w-full"><span className="break-all truncate block">{item?.productName || ""}</span></li>
                <li title={item?.instruction}>
                  {truncateString(item?.instruction, 120)}
                </li>
                <li className="action-last-colum">
                  <img
                    id={`edit-icon-${index + 1}`}
                    onClick={() =>
                      handleEdit(
                        item?._id || "",
                        queryParams.productType,
                        item?.productId || "",
                        item?.productName || "",
                        item
                      )
                    }
                    src={editIcon}
                    alt=""
                  />
                  <img
                    id={`prescribe-delete-btn-${index + 1}`}
                    onClick={() => handleDelete(item?._id || "")}
                    src={deleteIcon}
                    alt="delete"
                  />
                </li>
              </ul>
            ))}
          </CustomerTableWrapper>
        ) : null}
        {data.length ? (
          <div className="flex justify-end mb-2">
            <PrimaryBtn
              loader={shareLoader}
              ButtonText="Share"
              onPress={handleShare}
              btnExtraStyle={{
                borderRadius: "1.5rem",
                backgroundColor: "#004540",
                padding: "5px 30px",
              }}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default AppointmentPrescribe;
